module.exports = __webpack_public_path__ + "img/top_bar_close_white.187c3003.svg";